
(function () {
  'use strict';

  function visibleSlides(slider) {
    var slides = Array.prototype.slice.call(
      slider.querySelectorAll('.product-images__slide')
    );

    var active = slides.filter(function (slide) {
      return slide.classList.contains('is-active');
    });

    // Native navigation uses this set, including a temporary zero-active state.
    // Keep both gallery observers on the same count when native navigation owns it.
    if (active.length || slider.dataset.dalucaNavigationReady === 'true') return active;

    var visible = slides.filter(function (slide) {
      if (slide.hidden) return false;
      var ariaHidden = slide.getAttribute('aria-hidden');
      var style = window.getComputedStyle(slide);
      return ariaHidden !== 'true' && style.display !== 'none' && style.visibility !== 'hidden';
    });

    return visible.length ? visible : slides;
  }

  function updateSlider(slider) {
    if (!slider) return;

    var count = visibleSlides(slider).length;
    slider.classList.toggle('daluca-gallery--multiple', count > 1);
    slider.classList.toggle('daluca-gallery--single', count <= 1);

    var previousButton = slider.querySelector('.flickity-prev');
    var nextButton = slider.querySelector('.flickity-next');

    if (previousButton) {
      previousButton.setAttribute('role', 'button');
      previousButton.setAttribute('tabindex', '0');
      previousButton.setAttribute('aria-label', 'Previous product image');
    }
    if (nextButton) {
      nextButton.setAttribute('role', 'button');
      nextButton.setAttribute('tabindex', '0');
      nextButton.setAttribute('aria-label', 'Next product image');
    }

    var gallery = slider.closest('.product-gallery-container');
    if (gallery) {
      gallery.setAttribute('data-daluca-media-count', String(count));
    }
  }

  function initSlider(slider) {
    if (!slider || slider.dataset.dalucaUniversalGallery === 'true') return;

    slider.dataset.dalucaUniversalGallery = 'true';
    var resetPinch = initImagePinch(slider);
    initMobileImageSwipe(slider);
    updateSlider(slider);
    slider.setAttribute('tabindex','0');
    slider.setAttribute('aria-label','Product images. Use the left and right arrow keys to browse.');
    slider.addEventListener('keydown',function(event){
      if(event.target.closest('input,textarea,select,[contenteditable=true]'))return;
      var control=null;
      if(event.key==='ArrowLeft')control=slider.querySelector('.flickity-prev');
      if(event.key==='ArrowRight')control=slider.querySelector('.flickity-next');
      if((event.key==='Enter'||event.key===' ')&&event.target.matches('.flickity-nav'))control=event.target;
      if(control&&slider.classList.contains('daluca-gallery--multiple')){event.preventDefault();event.stopImmediatePropagation();control.click();}
    },true);

    var observer = new MutationObserver(function () {
      resetPinch(false);
      updateSlider(slider);
    });

    observer.observe(slider, {
      subtree: true,
      attributes: true,
      childList: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden', 'style']
    });

    window.addEventListener('resize', function () {
      resetPinch(true);
      updateSlider(slider);
    }, { passive: true });
  }

  function initMobileImageSwipe(slider) {
    var gesture = null, ignoreClickUntil = 0, sequence = 0;
    function settleImage(completed, cancelled) {
      if (sequence !== completed.sequence || slider.flkty !== completed.instance || !slider.isConnected) return;
      var instance = completed.instance;
      if (instance.isPointerDown || visibleSlides(slider).length < 2 || typeof instance.select !== 'function') return;
      instance.isDragging = false;
      delete instance.isPreventingClicks;
      if (instance.viewport) instance.viewport.classList.remove('is-pointer-down');
      var target = instance.selectedSlide && instance.selectedSlide.target;
      if (!cancelled && (typeof target !== 'number' || Math.abs(instance.x + target) <= 1)) return;
      instance.select(instance.selectedIndex, false, true);
    }
    function point(event, id, changed) {
      return Array.from(changed ? event.changedTouches : event.touches).find(function (touch) {
        return touch.identifier === id;
      });
    }
    slider.addEventListener('touchstart', function (event) {
      sequence += 1;
      gesture = null;
      if (window.innerWidth >= 768 || event.touches.length !== 1 || !slider.flkty) return;
      if (event.target.closest('a,button,input,select,textarea,video,iframe,model-viewer,.flickity-nav')) return;
      var image = event.target.closest('.product-images__slide.is-selected .product-single__media-image');
      if (!image || image.classList.contains('daluca-inline-pinched') || visibleSlides(slider).length < 2) return;
      var touch = event.touches[0];
      gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, dx: 0, dy: 0, intent: '', instance: slider.flkty, index: slider.flkty.selectedIndex, sequence: sequence };
    }, { capture: true, passive: true });
    slider.addEventListener('touchmove', function (event) {
      if (!gesture) return;
      if (event.touches.length !== 1) { gesture = null; return; }
      var touch = point(event, gesture.id, false);
      if (!touch) return;
      gesture.dx = touch.clientX - gesture.x;
      gesture.dy = touch.clientY - gesture.y;
      var dx = Math.abs(gesture.dx), dy = Math.abs(gesture.dy);
      if (!gesture.intent) {
        if (dx >= 8 && dx >= dy * 0.65) gesture.intent = 'horizontal';
        else if (dy >= 12 && dy > dx / 0.65) gesture.intent = 'vertical';
      }
      if (gesture.intent === 'horizontal' && event.cancelable) event.preventDefault();
    }, { capture: true, passive: false });
    slider.addEventListener('touchend', function (event) {
      if (!gesture) return;
      var touch = point(event, gesture.id, true);
      if (!touch) return;
      var completed = gesture;
      gesture = null;
      completed.dx = touch.clientX - completed.x;
      completed.dy = touch.clientY - completed.y;
      if (Math.max(Math.abs(completed.dx), Math.abs(completed.dy)) >= 8) ignoreClickUntil = Date.now() + 450;
      setTimeout(function () { settleImage(completed, false); }, 800);
      if (completed.intent === 'vertical' || Math.abs(completed.dx) < 28 || Math.abs(completed.dx) < Math.abs(completed.dy) * 0.65) return;
      if (event.cancelable) event.preventDefault();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (sequence !== completed.sequence || slider.flkty !== completed.instance || !slider.isConnected) return;
          if (slider.flkty.selectedIndex !== completed.index || visibleSlides(slider).length < 2) return;
          if (completed.dx < 0) slider.flkty.next();
          else slider.flkty.previous();
        });
      });
    }, { capture: true, passive: false });
    slider.addEventListener('touchcancel', function () {
      var cancelled = gesture;
      gesture = null;
      if (!cancelled) return;
      ignoreClickUntil = Date.now() + 450;
      requestAnimationFrame(function () { settleImage(cancelled, true); });
    }, { capture: true, passive: true });
    window.addEventListener('click', function (event) {
      if (Date.now() >= ignoreClickUntil || !slider.contains(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);
  }

  function initImagePinch(slider) {
    var frame=null, image=null, scale=1, x=0, y=0, gesture=null, draggable=null, ignoreClickUntil=0, sourcePromotion=null;
    function promoteImageSource() {
      if(sourcePromotion || !image || !frame)return;
      var zoom=frame.querySelector('.product-single__media-zoom');
      if(!zoom || !zoom.href || !(Number(zoom.getAttribute('data-w'))>0))return;
      var original=zoom.href;
      if(original===(image.currentSrc || image.src))return;
      var promotion={frame:frame,image:image,src:image.getAttribute('src'),srcset:image.getAttribute('srcset'),sizes:image.getAttribute('sizes'),applied:false,loader:new Image()};
      sourcePromotion=promotion;
      promotion.loader.onload=function(){
        if(sourcePromotion!==promotion || frame!==promotion.frame || image!==promotion.image || !frame.isConnected || !frame.closest('.product-images__slide.is-active.is-selected'))return;
        if(!promotion.loader.naturalWidth)return;
        promotion.applied=true;
        image.setAttribute('srcset',original+' 1x');
        image.setAttribute('src',original);
      };
      promotion.loader.onerror=function(){if(sourcePromotion===promotion)sourcePromotion=null;};
      promotion.loader.src=original;
    }
    function restoreImageSource() {
      var promotion=sourcePromotion;
      sourcePromotion=null;
      if(!promotion || !promotion.applied)return;
      ['src','srcset','sizes'].forEach(function(attribute){
        if(promotion[attribute]===null)promotion.image.removeAttribute(attribute);
        else promotion.image.setAttribute(attribute,promotion[attribute]);
      });
    }
    function unlock() {
      if(draggable!==null && typeof slider.setDraggable==='function') slider.setDraggable(draggable);
      draggable=null;
    }
    function reset(force) {
      if(!frame || (!force && frame.closest('.product-images__slide.is-active.is-selected')))return;
      frame.classList.remove('daluca-inline-pinched');
      ['--dl-pinch-x','--dl-pinch-y','--dl-pinch-scale'].forEach(function(p){frame.style.removeProperty(p);});
      restoreImageSource();
      frame=null;image=null;scale=1;x=0;y=0;gesture=null;unlock();
    }
    function touches(event) {
      return Array.from(event.touches).filter(function(t){return t.target.closest('.product-single__media-image')===frame;});
    }
    slider.addEventListener('touchstart',function(event){
      if(window.innerWidth>=768 || event.touches.length<2)return;
      var next=event.target.closest('.product-images__slide.is-selected .product-single__media-image');
      if(!next || event.target.closest('a,button'))return;
      if(frame!==next){reset(true);frame=next;image=frame.querySelector('img');}
      if(!image)return;
      var points=touches(event);if(points.length<2)return;
      event.preventDefault();event.stopPropagation();
      promoteImageSource();
      var a=points[0],b=points[1],rect=frame.getBoundingClientRect();
      gesture={distance:Math.max(1,Math.hypot(b.clientX-a.clientX,b.clientY-a.clientY)),scale:scale,x:x,y:y,midX:(a.clientX+b.clientX)/2,midY:(a.clientY+b.clientY)/2,centerX:rect.left+rect.width/2,centerY:rect.top+rect.height/2};
      if(draggable===null && slider.flkty && typeof slider.setDraggable==='function'){
        draggable=slider.flkty.options.draggable;slider.setDraggable(false);
      }
    },{capture:true,passive:false});
    slider.addEventListener('touchmove',function(event){
      if(!gesture)return;
      event.preventDefault();event.stopPropagation();
      var points=touches(event);if(points.length<2)return;
      var a=points[0],b=points[1],rect=frame.getBoundingClientRect();
      scale=Math.max(1,Math.min(4,gesture.scale*Math.hypot(b.clientX-a.clientX,b.clientY-a.clientY)/gesture.distance));
      var ratio=scale/gesture.scale,limitX=rect.width*(scale-1)/2,limitY=rect.height*(scale-1)/2;
      x=Math.max(-limitX,Math.min(limitX,(a.clientX+b.clientX)/2-gesture.centerX-(gesture.midX-gesture.centerX-gesture.x)*ratio));
      y=Math.max(-limitY,Math.min(limitY,(a.clientY+b.clientY)/2-gesture.centerY-(gesture.midY-gesture.centerY-gesture.y)*ratio));
      frame.style.setProperty('--dl-pinch-x',x+'px');frame.style.setProperty('--dl-pinch-y',y+'px');frame.style.setProperty('--dl-pinch-scale',String(scale));
      frame.classList.toggle('daluca-inline-pinched',scale>1);
    },{capture:true,passive:false});
    slider.addEventListener('touchend',function(event){
      if(!gesture)return;
      event.preventDefault();event.stopPropagation();ignoreClickUntil=Date.now()+400;
      if(!event.touches.length){gesture=null;unlock();if(scale===1)reset(true);}
    },{capture:true,passive:false});
    slider.addEventListener('touchcancel',function(){reset(true);},{passive:true});
    window.addEventListener('pointermove',function(event){if(gesture && event.pointerType==='touch')event.stopImmediatePropagation();},true);
    window.addEventListener('click',function(event){
      if(!slider.contains(event.target))return;
      if(Date.now()<ignoreClickUntil){event.preventDefault();event.stopImmediatePropagation();return;}
      if(frame && scale>1 && event.target===image){event.preventDefault();event.stopImmediatePropagation();reset(true);}
      else if(event.target.closest('a,button,.flickity-nav'))reset(true);
    },true);
    return reset;
  }

  function initAll() {
    document.querySelectorAll('.daluca-pdp product-slider.product-images').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  /* A few theme/product scripts finish after DOMContentLoaded. Re-check without
     rebuilding anything so late-initialized galleries get the same treatment. */
  window.addEventListener('load', initAll, { once: true });
  setTimeout(initAll, 250);
  setTimeout(initAll, 900);
})();


(function () {
  function bindColorFilms(scope) {
    if (scope.dataset.dalucaColorFilmsBound || scope.querySelector('variant-selects fieldset[data-handle="color"]')) return;
    scope.dataset.dalucaColorFilmsBound = 'true';
    let frame;
    function sync() {
      const slider = scope.querySelector('product-slider');
      if (!slider) return;
      const picker = Array.from(scope.querySelectorAll('.gpo-element')).find(field => {
        const label = window.DaLucaI18n.chainText(() => (field), [{kind:"member", optional:false, computed:false, key: () => ("querySelector")}, {kind:"call", optional:false, args: () => ['.gpo-label .label-content']}, {kind:"text", optional:true}, {kind:"member", optional:false, computed:false, key: () => ("trim")}, {kind:"call", optional:false, args: () => []}]) || '';
        return /^(?:(?:leather|strap|nylon|shell cordovan|lizard|alligator|crocodile)\s+)?colou?r$/i.test(label) && !field.hidden && getComputedStyle(field).display !== 'none';
      });
      if (!picker) return;
      const selected = picker.querySelector('input[type="radio"]:checked')?.value || picker.querySelector('select')?.value || '';
      const group = selected ? 'color_' + selected.toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') : '';
      let changed = false;
      Array.from(slider.querySelectorAll('.product-images__slide[data-group^="color_"]')).filter(slide => slide.querySelector('video')).forEach(slide => {
        const active = slide.dataset.group === group;
        if (slide.classList.contains('is-active') !== active) changed = true;
        slide.classList.toggle('is-active', active);
        if (!active) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      scope.querySelectorAll('.product-thumbnail[data-group^="color_"]').forEach(thumb => {
        if (thumb.querySelector('.product-thumbnail-icon')) thumb.classList.toggle('is-active', thumb.dataset.group === group);
      });
      if (changed && slider.flkty) slider.reInit();
    }
    function queueSync() { cancelAnimationFrame(frame); frame = requestAnimationFrame(sync); }
    scope.addEventListener('change', queueSync);
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.gpo-element,.gpo-app,input,select') || node.querySelector('.gpo-element,.gpo-app,input,select'))))) queueSync();
    }).observe(scope, { childList: true, subtree: true });
    queueSync();
  }
  function initColorFilms() { document.querySelectorAll('.thb-product-detail').forEach(bindColorFilms); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initColorFilms, { once: true });
  else initColorFilms();
  document.addEventListener('shopify:section:load', initColorFilms);
})();

